export var log = function (msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (window.rm_log)
        window.rm_log(msg, args);
    else
        console.log(msg, args);
};
export default log;
